<template>
  <div style="padding: 10px;">
    <div style="font-weight: bold;margin: 8px 0 20px 6px" @click="toNodeDetail">审批流程 -
      <span style="font-size: 10px;font-weight: normal;color: #409EFF">节点详情</span>
    </div>
    <div style="overflow:auto;height: 58vh">
      <div style="height: 10px"></div>
      <el-timeline>
        <el-timeline-item v-for="(nodeItem) in approver" :key="nodeItem.id" placement="top">
          <div v-if="!nodeItem.hasOwnProperty('options')" class="card">
            <div style="display: flex;justify-content: space-between">
              <div style="margin-bottom: 10px">
                <span class="node-title">{{nodeItem.title}}</span>
                <span v-if="nodeItem.desc"> - </span>
                <span class="node-describe">{{nodeItem.desc}}</span>
              </div>
              <div>
                <div v-if="formDetail.state == 2">
                  <el-image v-if="nodeItem.icon == 'refuse' ||  nodeItem.id == 'root'"
                            :src="require('/src/assets/image/refuse-tool.png')" style="width: 20px; height: 20px"/>
                </div>
                <div v-else>
                  <el-image v-if="nodeItem.icon == 'end' || nodeItem.icon == 'consent'" :src="require('/src/assets/image/agree.png')" style="width: 20px; height: 20px"/>
                  <el-image v-if="nodeItem.icon == 'refuse'" :src="require('/src/assets/image/refuse-tool.png')" style="width: 20px; height: 20px"/>
                  <span v-if="nodeItem.icon == 'running'" style="font-size: 17px" class="el-icon-loading"></span>
                </div>
              </div>
            </div>
            <div style="display: flex;justify-content: space-between;flex-wrap: wrap">
              <div v-for="(user, index) in nodeItem.users"  :key="index">
                <el-popover placement="left" width="340" trigger="click">
                  <div>
                    <div v-if="userComment && userComment.optionVOList!=null && userComment.optionVOList.length>0" class="comment-item">
                      <div style="font-size: 14px;margin:6px 0px 2px 0px;font-weight: bold;text-align: center">审批</div>
                      <div v-for="(item,index) in userComment.optionVOList" :key="index">
                        <div class="comment-info">{{item.comments}}</div>
                        <div class="comment-images" style="background-color: white;border-radius: 10px">
                          <el-image class="image-item"
                                    :src="img.url" :preview-src-list="previewUrls(item.images)" v-for="(img, index) in item.images.slice(0, 5)" :key="index"/>
                        </div>
                      </div>
                    </div>
                    <div v-else class="comment-item" style="height: 120px">
                      <div style="font-size: 14px;padding:12px;font-weight: bold;text-align: center">审批</div>
                      <div style="height: 66px;background-color: white;border-radius: 10px">
                      </div>
                    </div>
                  </div>
                  <template #reference>
                    <div class="user-item" v-if="user" @click="selectUserComment(nodeItem,index)">
                      <div class="user-state" v-if="user.state">
                        <el-image v-if="user.state == 'consent'" :src="require('/src/assets/image/agree.png')" style="width: 16px; height: 16px"/>
                        <el-image v-if="user.state == 'refuse'" :src="require('/src/assets/image/refuse-tool.png')" style="width: 16px; height: 16px"/>
                        <span v-if="user.state == 'running'" style="font-size: 17px" class="el-icon-loading"></span>
                      </div>
                      <el-avatar shape="square" class="user-avatar" :src="user.avatar"></el-avatar>
                      <div class="user-name">{{user.name}}</div>
                    </div>
                  </template>
                </el-popover>
              </div>
              <div v-for="(item) in 30" style="width: 60px" :key="`placeholder-${item}`"></div>
            </div>
            <div v-for="(item,index) in formDetail.nodeCommentList[nodeItem.id]" :key="index" class="node-comment-info">
              <div>{{item.userName}}：{{item.comments}}</div>
              <div v-if="item.images.length>0" class="comment-images">
                <el-image class="image-item" :src="img.url" :preview-src-list="previewUrls(item.images)" v-for="(img, index) in item.images.slice(0, 5)" :key="index"/>
              </div>
            </div>
            <div v-for=" (system,systemIndex) in nodeItem.comments" :key="systemIndex">
              <div v-if="system.success == true">
                <div v-if="system.type == 'excel'">
                  <div v-for="(file,fileIndex) in system.fileList" :key="fileIndex" @click="downloadFileByUrl(file)" class="file-item">
                    <div>
                      <div style="font-size: 14px;margin-bottom: 4px">附件{{fileIndex+1}}</div>
                      <div style="font-size: 12px;color:#909399"><span class="el-icon-tickets"></span> {{file.name}}</div>
                    </div>
                    <span style="color: #2a99ff;font-size: 18px" class="el-icon-download"></span>
                  </div>
                </div>
              </div>
              <div v-else class="message">
                <div style="font-weight: bold;margin-bottom: 6px">错误提示</div>
                <div style="color: #909399">{{system.message}}</div>
              </div>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <el-drawer
        destroy-on-close
        title="评论信息"
        :modal="false"
        size="540px"
        direction="btt"
        :visible.sync="userCommentDrawer"
    >
    </el-drawer>
  </div>
</template>

<script>
import { selectApprover } from "@/api/org";
import {downloadALink} from "../../../utils/fileUtils";
import {selectSonDeptTreeById, treeIsIncludeById} from "../../../utils/deptDispose";
export default {
  name: "AuditFlow",
  data() {
    return {
      approver:[],
      a:[],
      process:{},
      userComment:null,
      userCommentDrawer:false,
      conditionFormItem: new Set(),
      initiator: {},
      formDetail:{
        runningUserList:[],
        detailVOList:[],
        nodeCommentList:[]
      },
    }
  },
  methods:{
    previewUrls(list) {
      return list.map(item => item.url);
    },
    downloadFileByUrl(val){
      if (val.url == null){
        this.$message.warning("未检测到线上文件地址！");
        return false;
      }
      downloadALink(val.url,val.name);
    },
    toList(list){
      let imageList = [];
      for (const item of list) {
        imageList.push(item.url);
      }
      return imageList;
    },
    selectUserComment(nodeItem,index){
      console.log(nodeItem)
      let userList = this.$store.state.detailVOList[nodeItem.id];
      console.log(userList)
      if (userList == null || userList[index] == null){
        this.userComment = null;
      }else {
        this.userComment = userList[index];
      }
    },
    toNodeDetail(){
      this.$router.push({
        path: "/workspaceMini/process/instance/tabs/processDiagramViewer"
      });
    },
    selectApprover(processInstanceId){
      console.log(this.formDetail)
      let query = {list:this.approver,userId:this.initiator.id,"processInstanceId":processInstanceId}
      selectApprover(query).then(val => {
        this.approver = JSON.parse(JSON.stringify(val.data));
        for (const item of this.approver) {
          if (this.$store.state.runningList.includes(item.id)) {
            item.icon = "running";
          }
          if (this.$store.state.endList.includes(item.id) && this.$store.state.detailVOList[item.id]!=null) {
            item.icon = "end";
          }
          for (const user of item.users) {
            if (user){
              for (const audit of this.formDetail.runningUserList) {
                if (item.id == audit.nodeId && user.id == audit.userId) {
                  user.state = "running";break;
                }
              }
              for (const audit of this.$store.state.auditList) {
                if (item.id == audit.nodeKey && user.id ==audit.userId){
                  user.state = audit.state;break;
                }
              }
            }
          }
        }
        console.log(this.approver)
      })
    },
    startProcess(process,result,processInstanceId) {
      this.approver = [];
      this.formDetail = result;
      let detail = result.detailVOList;
      this.initiator = detail.root[0].user;
      this.process = JSON.parse(JSON.stringify(process));
      console.log(this.process)
      this.getProcess(this.process, detail, this.approver);
      this.selectApprover(processInstanceId);
    },
    getProcess(process, detail, cc) {
      if (null != process && undefined != process) {
        if ("ROOT" === process.type) {
          //发起人节点
          this.getRootNode(cc, process);
        } else if ("APPROVAL" === process.type) {
          this.getApprovalNode(cc, process,detail);
        } else if ("TASK" === process.type){
          this.getApprovalNode(cc, process,detail);
        }
        else if ("CC" === process.type) {
          this.getCcNode(cc, process);
        } else if ("CONDITIONS" === process.type) {
          //判断是否符合条件符合走条件分支,否则继续递归子分支
          if (null != process.branchs && undefined != process.branchs) {
            console.log(process)
            this.getConditionNode(cc, process);
          }
        } else if ("CONCURRENTS" === process.type) {
          this.getConcurrentNode(cc, process);
        }
        if (null != process.children && undefined != process.children) {
          this.getProcess(process.children, detail, cc);
        }
      }
    },
    //封装开始节点
    getRootNode(cc, process) {
      console.log(process)
      cc.push({
        id: process.id,
        title: process.name,
        name: "发起人",
        icon: "el-icon-user-solid",
        isEdit: false,
        users: [this.initiator],
      });
    },
    //封装审批节点
    getApprovalNode(cc, process,detail) {
      let users = [];
      let endNode = this.formDetail.detailVOList[process.id];
      console.log(endNode)
      for (const item of endNode || []) {
        users.push(item.user);
      }
      var data = {
        id: process.id,
        title: process.name,
        name: "审批人",
        type:process.props.assignedType,
        isEdit: false,
        multiple: false,
        mode: process.props.mode,
        users: users,
        desc: "",
      };
      //判断审批人类型
      switch (process.props.assignedType) {
        case "ASSIGN_USER":
          data.users = this.$deepCopy(process.props.assignedUser);
          data.desc = "指定审批人";
          break;
        case "ASSIGN_LEADER":
          data.desc = "指定部门的领导";
          break;
        case "SELF":
          data.users = [this.loginUser];
          data.desc = "发起人自己审批";
          break;
        case "SELF_SELECT":
          data.isEdit = true;
          data.multiple = process.props.selfSelect.multiple || false;
          data.desc = "自选审批人";
          break;
        case "LEADER_TOP":
          var leaderTop = process.props.leaderTop;
          if (leaderTop.endCondition == 'TOP'){
            data.desc = "连续多级主管审批";
          }else {
            data.leader = leaderTop.level;
            data.desc = "连续"+leaderTop.level+"级主管审批";
          }
          break;
        case "LEADER":
          data.leader = process.props.leader.level;
          data.desc = 1 === process.props.leader.level ? "主管审批" : "第".concat(process.props.leader.level, "级主管审批");
          break;
        case "ROLE":
          data.role = process.props.role;
          data.desc = "[".concat((process.props.role || []).map(function (e) {return e.name;}), "]"
          );
          break;
        case "APPOINT_ROLE":
          data.role = process.props.role;
          data.desc = "[".concat((process.props.role || []).map(function (e) {return e.name;}), "]"
          );
          break;
        case "REFUSE":
          data.desc = "流程此处将被自动驳回";
          break;
      }
      cc.push(data);
    },
    getCcNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        icon: "el-icon-s-promotion",
        name: "抄送人",
        isEdit: process.props.shouldAdd,
        type: "org",
        multiple: true,
        desc: process.props.shouldAdd ? "可添加抄送人" : "",
        users: this.$deepCopy(process.props.assignedUser),
      };
      cc.push(data);
    },
    getConditionNode(cc, process) {
      for (var r = null, s = 0; s < process.branchs.length; s++) {
        for (
            var a = process.branchs[s], n = false, o = 0, i = 0;
            i < a.props.groups.length;
            i++
        ) {
          if (
              ((n = this.getConditionResultByGroup(a.props.groups[i])),
              "OR" === a.props.groupsType && n)
          ) {
            r = a;
            break;
          }
          "AND" === a.props.groupsType && n && o++;
        }

        if (r) {
          break;
        }
        if (o === a.props.groups.length) {
          r = a;
          break;
        }
      }
      var d = [];
      console.log(
          "符合分支条件,继续执行递归,获取符合条件下节点下的子节点!" +
          JSON.stringify(r)
      );
      r
          ? this.getProcess(r, d, cc)
          : console.log(
          "条件节点 "
              .concat(process.id, " => ")
              .concat(process.name, " 均不满足，无法继续"),
          process
          );
    },
    getConcurrentNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        name: "并行分支",
        icon: "el-icon-s-operation",
        isEdit: false,
        active: process.branchs[0].id,
        options: [],
        desc: "切换分支可显示对应执行流程",
        branchs: {},
      };
      cc.push(data);
      process.branchs.forEach((b) => {
        data.options.push({ id: b.id, title: b.name });
        this.$set(data.branchs, b.id, []);
        var d = [];
        this.getProcess(b.children, d, data.branchs[b.id]);
      });
    },
    getConditionResultByGroup: function (e) {
      var t = this,
          r = !1,
          s = 0;
      e.conditions.forEach(function (e) {
        return t.conditionFormItem.add(e.id);
      });

      for (var a = 0; a < e.conditions.length; a++) {
        var n = e.conditions[a];
        switch (n.valueType) {
          case "Number":
            console.log("这是number类型判断");
            r = this.numberCompare(n);
            break;
          case "String":
            console.log("这是string类型判断");
            break;
          case "Date":
            console.log("这是data类型判断");

            break;
          case "User":
            r = this.userCompare(n.value);
            break;
          case "Dept":
            r = this.deptCompare(n.value);
            console.log("这是dept类型判断");
            break;
          case "ChoiceDept":
            r = this.choiceDeptCompare(n);
            console.log("这是ChoiceDept类型判断");
            break;
          case "Array":
            console.log("这是array类型判断");

            break;
        }
        if (r && "OR" === e.groupType) break;
        r && "AND" === e.groupType && s++;
      }
      return "AND" === e.groupType && (r = s === e.conditions.length), r;
    },
    numberCompare: function (e) {
      var t = this.formData[e.id];
      switch (e.compare) {
        case ">":
          return t > parseFloat(e.value[0]);
        case "<":
          return t < parseFloat(e.value[0]);
        case "=":
          return t === parseFloat(e.value[0]);
        case ">=":
          return t >= parseFloat(e.value[0]);
        case "<=":
          return t <= parseFloat(e.value[0]);
        case "B":
          return t > parseFloat(e.value[0]) && t < parseFloat(e.value[1]);
        case "AB":
          return t >= parseFloat(e.value[0]) && t < parseFloat(e.value[1]);
        case "BA":
          return t > parseFloat(e.value[0]) && t <= parseFloat(e.value[1]);
        case "ABA":
          return t >= parseFloat(e.value[0]) && t <= parseFloat(e.value[1]);
        case "IN":
          return e.value.indexOf(String(t)) > -1;
        default:
          return !1;
      }
    },
    /**
     * 条件分支 - 判断用户是否是设置的（部门、部门子部门的用户）
     */
    deptCompare(deptList){
      let deptTree = JSON.parse(localStorage.getItem("deptTree"));
      for (const dept of deptList) {
        //查找设置部门id的子级
        let list = selectSonDeptTreeById(deptTree,dept.id);
        //查找当前用户是否符合条件
        let result = selectSonDeptTreeById([list],this.initiator.deptId);
        console.log(result)
        if (result && result.id){
          return true;
        }
      }
    },
    /**
     * 条件分支 - 判断用户选择的部门是否符合条件
     */
    choiceDeptCompare: function (val) {
      let formItem = this.formDetail.formData[val.id];
      if (formItem != null) {
        return treeIsIncludeById(val.value, formItem.map(item => item.id));
      }
      return false;
    },
    /**
     * 条件分支 - 判断用户是否（部门、用户列表）
     */
    userCompare(users) {
      for (const user of users) {
        if (user.id  === this.initiator.id){
          return true;
        }
      }
    }
  },
}
</script>

<style lang="less" scoped>
.card{
  box-shadow: 0px 0px 8px rgba(99, 99, 99, 0.1);
  margin: -10px 10px 0 0;
  padding:12px;
  border-radius: 8px;
  .node-title{
    font-size: 15px;
    font-weight: bold;
  }
  .node-describe{
    color: #4b4b4b;
    font-size: 12px;
    font-weight: normal
  }
  .user-item{
    width: 60px;
    margin: 6px 0;
    text-align: center;
    position: relative;
    .delete-user{
      position:absolute;
      top: -6px;
      right: 6px;
      color: red;
      background-color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      font-weight: normal;
      border-radius: 50%;
      padding: 2px;
    }
    .user-avatar{
      height: 36px;
      width: 36px;
      line-height: 36px;
      background-color: #2a99ff;
    }
    .user-name{
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 显示省略号 */
      font-size: 14px;
      color: #909399;
    }
    .user-state{
      position:absolute;
      bottom: 13px;
      right: 6px;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      padding: 0;
    }
  }
  .add-user{
    border: #909399 dashed 1px;
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 7px;
    font-weight: normal;
    color: #909399;
    margin: 6px 10px 0 10px;
  }
}
.node-comment-info{
  border-radius: 10px;
  padding:6px 10px;
  font-size: 12px;
  color: #909399;
  .comment-images{
    margin:10px 0 10px 50px;
    background-color: #F5F7FA;
    border-radius: 10px;
    padding: 2px 4px;
  }
}
.image-item{
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 4px;
  margin:8px 6px 6px 6px;
}
.attachment{
  background-color: white;
}
.comment-item{
  background-color: #F5F7FA;
  margin: 10px 14px;
  border-radius: 12px;
  padding: 2px 10px 10px 10px;
}
.comment-info{
  background-color: white;padding: 10px;border-radius: 8px;font-size: 12px;color: #606266;
  height: 60px;
  overflow: auto;
  margin: 10px 0;
}
.file-item{
  display: flex;
  align-items: center;
  background-color: #F2F6FC;
  border-radius: 12px;
  padding: 10px 16px;
  justify-content: space-between;
}
.message{
  background-color: #F2F6FC;
  border-radius: 12px;
  padding: 10px 16px;
}
</style>